import React, { useEffect, useMemo } from "react";
import ReactWebChat, {
  createDirectLine,
  createStyleSet,
} from "botframework-webchat";

import "./WebChat.css";

import LccChatbotLogoEyesOpen from "./images/LCC Chatbot_black_no speech bubble.svg";

const colourWhite = "rgba(255, 255, 255, 1)";
const colourDarkBlue = "rgba(0, 47, 69, 1)";
const colourLightGrey = "rgba(236, 236, 236, 1)";
const colourDarkGrey = "rgba(43, 43, 43, 1)";
const colourGreen = "rgba(46, 125, 50, 1)";
const colourLightGreen = "rgba(53, 144, 57, 1)";
const colourOrange = "rgba(255, 191, 71, 1)";
const colourBlack = "rgba(0, 0, 0, 1)";

const messageCornerRadius = 8;
const nubSize = 30;
const nubOffset = 10;
const suggestionButtonHeight = 35;

const WebChat = ({
  className,
  onFetchToken,
  onFetchStore,
  store,
  token,
  tokenInvalid,
}) => {
  const directLine = useMemo(() => createDirectLine({ token }), [token]);

  // some styles have no effect in styleOptions and need to be set in styleSet and vice-versa
  const styleSet = useMemo(
    () =>
      createStyleSet({
        backgroundColor: colourWhite,

        // bot messages
        bubbleTextColor: colourDarkGrey,
        bubbleBackground: colourLightGrey,
        bubbleBorderColor: colourLightGrey,
        bubbleBorderRadius: messageCornerRadius,
        bubbleNubOffset: nubOffset,

        // user messages
        bubbleFromUserBackground: colourDarkBlue,
        bubbleFromUserBorderColor: colourDarkBlue,
        bubbleFromUserTextColor: colourWhite,
        bubbleFromUserBorderRadius: messageCornerRadius,
        bubbleFromUserNubOffset: nubOffset,

        // suggestion buttons
        suggestedActionBackgroundColor: colourGreen,
        suggestedActionBorderColor: colourGreen,
        suggestedActionTextColor: colourWhite,
        suggestedActionHeight: suggestionButtonHeight,
        suggestedActionBackgroundColorOnFocus: colourOrange,
        suggestedActionBackgroundColorOnActive: colourOrange,
        suggestedActionBackgroundColorOnHover: colourLightGreen,
        suggestedActionBorderColorOnFocus: colourBlack,
        suggestedActionBorderColorOnActive: colourBlack,
        suggestedActionTextColorOnFocus: colourBlack,
        suggestedActionTextColorOnActive: colourBlack,
        suggestedActionKeyboardFocusIndicatorBorderWidth: 0,

        // send button
        sendBoxButtonShadeColorOnFocus: colourOrange,
        sendBoxButtonColorOnFocus: colourBlack,
        sendBoxButtonShadeColorOnHover: colourGreen,
        sendBoxButtonColorOnHover: colourWhite,
        sendBoxButtonShadeColorOnActive: colourOrange,
        sendBoxButtonColorOnActive: colourBlack,
        sendBoxButtonKeyboardFocusIndicatorBorderWidth: 0,

        sendBoxBorderTop: "solid 4px " + colourDarkBlue,
      }),
    []
  );

  const customStyleOptions = {
    hideUploadButton: true,
    suggestedActionLayout: "stacked",

    bubbleNubSize: nubSize,
    bubbleFromUserNubSize: nubSize,
  };

  useEffect(() => {
    onFetchToken();
  }, [onFetchToken]);

  useEffect(() => {
    onFetchStore();
  }, [onFetchStore]);

  // eslint-disable-next-line eqeqeq
  if (token == tokenInvalid) {
    return (
      <div>
        <div className="error-message">
          <p>Error: a problem has occurred</p>
          <br />
          <p>Unable to connect.</p>
        </div>
      </div>
    );
  }

  return token ? (
    <ReactWebChat
      className={`${className || ""} web-chat`}
      directLine={directLine}
      store={store}
      styleSet={styleSet}
      styleOptions={customStyleOptions}
    />
  ) : (
    <div className={`${className || ""} connect-spinner`}>
      <img src={LccChatbotLogoEyesOpen} alt="" />
      <p>Loading...</p>
    </div>
  );
};

export default WebChat;
